import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("ihmj_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me").then(r => setUser(r.data.user)).catch(() => {
      localStorage.removeItem("ihmj_token");
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ihmj_token", data.token);
    setUser(data.user);
  };
  const loginWithToken = (data) => {
    localStorage.setItem("ihmj_token", data.token);
    setUser(data.user);
  };
  const register = async (email, password, name) => {
    await api.post("/auth/register", { email, password, name });
    await login(email, password);
  };
  const logout = () => {
    localStorage.removeItem("ihmj_token");
    setUser(null);
  };
  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data.user);
  };

  return <AuthCtx.Provider value={{ user, loading, login, loginWithToken, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
